import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Slider from 'react-slick';

import { BID_CLASSES_CAROUSEL } from '../../data/constants';

import './styles.scss';

const CustomSlider = props =>  {
  const [activeTabIndex, setActiveTabIndex] = useState(0)
  const [tabs, setTabs] = useState([])

  useEffect(() => {
    if (props.tabs !== tabs) {
      setTabs(props.tabs);
    }
  }, [props.tabs])

  useEffect(() => {
    if (props.editPrefFromCombinedPreferenceClassId && tabs.length > 0) {
      const targetIndex = props.editPrefFromCombinedPreferenceClassId - 1;
      if (targetIndex >= 0 && targetIndex < tabs.length && targetIndex !== activeTabIndex) {
        setActiveTabIndex(targetIndex);
      }
    }
  }, [props.editPrefFromCombinedPreferenceClassId, tabs]);
  
  const handleTabClick = tabIndex => {
    setActiveTabIndex(tabIndex);
    if (props.onTabChange) {
      props.onTabChange(tabIndex);
    }
  };

  const settings = !props.openCombinedPreferences ? {
    dots: BID_CLASSES_CAROUSEL.dots,
    infinite: BID_CLASSES_CAROUSEL.infinite,
    speed: BID_CLASSES_CAROUSEL.speed,
    slidesToShow: window.innerWidth > 600 ? BID_CLASSES_CAROUSEL.slidesToShow : BID_CLASSES_CAROUSEL.slidesToShowSmallCreen,
    slidesToScroll: BID_CLASSES_CAROUSEL.slidesToScroll
  } : {
    dots: BID_CLASSES_CAROUSEL.dots,
    infinite: BID_CLASSES_CAROUSEL.infinite,
    speed: BID_CLASSES_CAROUSEL.speed,
    slidesToShow: BID_CLASSES_CAROUSEL.combinedPreferencesSlidesToShow,
    slidesToScroll: BID_CLASSES_CAROUSEL.combinedPreferencesSlidesToScroll
  };

  return (
    <div>
      {
        tabs.length > 0 ? ( 
          <Slider {...settings}>
            {tabs.map((tab, index) => (
              <div
                key={index}
                className={` ${tab.className} tab-header ${
                  activeTabIndex === index ? 'active' : ''
                }`}
                onClick={() => handleTabClick(index)}
              >
                {tab?.label}
              </div>
            ))}
          </Slider>) : null
      }
      {tabs.length > 0 ? ( <div className='tab-content'>{tabs[activeTabIndex]?.content}</div>) : null}
    </div>
  );
}

CustomSlider.propTypes = {
  tabs: PropTypes.array.isRequired,
  editPrefFromCombinedPreferenceClassId: PropTypes.number,
};

export default CustomSlider;
